import { generatePath, Navigate } from "react-router";

import type { LangCode } from "@/lib/gql/__generated__/graphql";

import { PATHS } from "@/routes/paths";

import type { FeatureIslandHeaderLangNavigatorProps } from "@/components/features/_layouts";

import { DayTripPlanI18nEditPresenter } from "./presenter";
import { useDayTripPlanI18nEditQuery } from "../../model/repository/existing/query/use-day-trip-plan-edit-query";

type Props = {
	hotelID: string;
	planID: string;
	activeLangCode: LangCode;
	navigator: FeatureIslandHeaderLangNavigatorProps;
};

export const DayTripPlanI18nEditContainer = ({ hotelID, planID, activeLangCode, navigator }: Props) => {
	const serverModel = useDayTripPlanI18nEditQuery({ hotelID, planID, lang: activeLangCode });

	if (!serverModel) {
		return <Navigate to={generatePath(PATHS.HOTEL.ITEMS.PLAN.TOP, { hotelID })} />;
	}

	return (
		<DayTripPlanI18nEditPresenter activeLangCode={activeLangCode} navigator={navigator} serverModel={serverModel} />
	);
};

DayTripPlanI18nEditContainer.displayName = "DayTripPlanI18nEditContainer";
